import {css} from 'lit';

// language=CSS
export const imageInputEntry =
    css`
        :host {
            position: relative;
            height: 100%;
            width: 100%;
            display: block;
        }
        
        .image {
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            background-color: #fff;
            box-shadow: var(--sp-default-box-shadow);
            box-sizing: border-box;
            border-radius: 3px;
            cursor: pointer;
        }

        .image.bubble {
            width: 100%;
            aspect-ratio: 1 / 1;
            border-radius: 50%;
            border: 3px solid #fff;
            background-size: cover !important
        }

        .root-image {
            display: block;
            width: 100%;
            height: 115px;
            background-size: cover;
            background-position: center center;
            border-radius: 3px;
            cursor: pointer;
        }`;
